// eslint-disable-next-line import/prefer-default-export
export enum Resolution {
  '720p' = 720,
  '1080p' = 1080,
  '1440p' = 1440,
  '2160p' = 2160,
}
